/* Guide chapter navigation: highlights the chapter being read in the index and keeps the sticky index clear of the sticky header.
   There is no cart code here: Add to basket is a standard Shopify form, and the theme's own script (class Sd_addProduct) adds the item and opens the side cart. */
(function () {
  var root = document.querySelector('.smg[data-guide]');
  if (!root) return;
  var header = document.querySelector('.shopify-section-main-header');
  if (header && 'ResizeObserver' in window) {
    new ResizeObserver(function () {
      root.style.setProperty('--smg-header-height', Math.ceil(header.getBoundingClientRect().height) + 'px');
    }).observe(header);
  }
  var toast = root.querySelector('.productErrors'), timer;
  if (toast && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (toast.style.display === 'none' || !toast.textContent.trim()) return;
      clearTimeout(timer);
      timer = setTimeout(function () { toast.style.display = 'none'; }, 7000);
    }).observe(toast, { attributes: true, attributeFilter: ['style'], childList: true });
  }
  if (!('IntersectionObserver' in window)) return;
  var links = root.querySelectorAll('.index a[href^="#"]');
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      links.forEach(function (link) {
        var active = link.hash === '#' + entry.target.id;
        link.classList.toggle('active', active);
        if (active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    });
  }, { rootMargin: '-20% 0px -60% 0px' });
  root.querySelectorAll('.tool').forEach(function (section) { observer.observe(section); });
})();
